import { useEffect, useState } from "react";
import { materialRepo } from "@/services/material.repository";
import type { MaterialCategory } from "@/domain/material";

export function useMaterialCategories() {
  const [data, setData] = useState<MaterialCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const unsub = materialRepo.watch(
      (rows) => {
        setData(rows);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err);
        setLoading(false);
      },
    );
    return unsub;
  }, []);

  return { data, loading, error };
}
